<template>
  <v-container id="contact-form">
    <v-row class="">
      <v-col cols="12">
        <v-alert
          dense
          border="start"
          type="success"
          v-model="displaySuccessMsg"
          icon="$check"
          transition="slide-y-reverse-transition"
          class="mb-8"
        >
          {{ $t("forms.confirmMsgSent") }}
        </v-alert>
        <v-alert
          dense
          border="start"
          type="warning"
          v-model="displayFormError"
          icon="$exclamationTriangle"
          transition="slide-y-reverse-transition"
          class="mb-8"
        >
          {{ formErrorMsg }}
        </v-alert>
        <v-form ref="form" v-model="formValid" @submit="submit">
          <v-text-field
            color="#33A390"
            :disabled="displaySuccessMsg"
            variant="outlined"
            :label="$t('forms.fields.name')"
            v-model="name"
            :rules="requiredRule($t('forms.fields.name'))"
            class="mb-4"
          ></v-text-field>
          <v-text-field
            color="#33A390"
            :disabled="displaySuccessMsg"
            variant="outlined"
            :label="$t('forms.fields.email')"
            v-model="email"
            :rules="emailRule"
            class="mb-4"
          ></v-text-field>
          <v-textarea
            color="#33A390"
            :disabled="displaySuccessMsg"
            variant="outlined"
            :label="$t('forms.fields.message')"
            v-model="message"
            :rules="requiredRule($t('forms.fields.message'))"
            rows="10"
            class="mb-4"
          ></v-textarea>
          <div class="d-flex form-btn-container">
            <v-btn
              flat
              @click="submit"
              :loading="formProcessing"
              color="success"
              prepend-icon="$envelope"
              class="mx-4 text-white"
            >
              {{ $t("forms.send") }}
            </v-btn>
            <v-btn
              flat
              text
              @click="reset"
              :disabled="formProcessing"
              color="lightBg"
              class="mx-4"
            >
              {{ $t("forms.reset") }}
            </v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default defineComponent({
  name: "ContactForm",

  setup() {
    const { t } = useI18n();
    const form = ref();
    const formValid = ref(true);
    const formProcessing = ref(false);
    const email = ref("");
    const name = ref("");
    const message = ref("");
    const displaySuccessMsg = ref(false);
    const displayFormError = ref(false);
    const formErrorMsg = ref("");
    const config = useRuntimeConfig();
    const mailerUrl = config.public.awsSettings.webform_mailer;
    const mailerKey = config.public.awsSettings.webform_mailer_key;

    const clearFormError = () => {
      formErrorMsg.value = "";
      displayFormError.value = false;
    };

    const submit = async () => {
      await form.value.validate();
      if (formValid.value) {
        clearFormError();
        formProcessing.value = true;
        useFetch(mailerUrl, {
          method: "post",
          headers: {
            "x-api-key": mailerKey,
          },
          body: {
            name: name.value,
            email: email.value,
            message: message.value,
          },
        })
          .then(() => {
            displaySuccessMsg.value = true;
            formProcessing.value = false;
          })
          .catch(() => {
            formProcessing.value = false;
          });
      } else {
        formErrorMsg.value = t("forms.errorAlert");
        displayFormError.value = true;
      }
    };

    const reset = () => {
      [email, name, message].forEach((fld) => {
        fld.value = "";
      });
      displaySuccessMsg.value = false;
      displayFormError.value = false;
      formValid.value = true;
      form.value.reset();
    };

    return {
      form,
      formValid,
      formProcessing,
      email,
      name,
      message,
      displaySuccessMsg,
      displayFormError,
      formErrorMsg,
      submit,
      reset,
      ...ruleUtils().getRules(["requiredRule", "emailRule"]),
    };
  },
});
</script>
<style lang="scss" scoped>
</style>
